<script setup lang="ts">
import type { FormSubmitEvent } from 'ui/util/ui/import';
import { onFormErrorScrollFocus } from 'ui/util/onFormError';

import {
  studentSearchSchema,
  type StudentSearchFormValues,
} from './schema';

const props = defineProps<{
  initialValues?: Partial<StudentSearchFormValues>;
  loading?: boolean;
  disabled?: boolean;
  onSubmit: (values: StudentSearchFormValues) => void | Promise<void>;
}>();

const state = reactive<StudentSearchFormValues>({
  q: props.initialValues?.q ?? '',
});

const handleSubmit = async (
  event: FormSubmitEvent<StudentSearchFormValues>,
): Promise<void> => {
  await props.onSubmit(event.data);
  state.q = '';
};
</script>

<template>
  <UForm
    :schema="studentSearchSchema"
    :state="state"
    :novalidate="true"
    data-cy="sidebar-student-search"
    @submit="handleSubmit"
    @error="onFormErrorScrollFocus"
  >
    <UFormField
      name="q"
      label="Search by student"
      :ui="{ labelWrapper: 'sr-only' }"
    >
      <UInput
        id="sidebar-student-search"
        v-model="state.q"
        name="q"
        type="search"
        placeholder="Search by student..."
        autocomplete="off"
        class="w-full"
        size="lg"
        :disabled="disabled || loading"
        :ui="{
          base: 'bg-primary-50',
        }"

      >
        <template #leading>
          <UiFaIcon
            :icon="['fal', 'magnifying-glass']"
            class="text-(--color-sidebar-menu-text)"
            aria-hidden="true"
          />
        </template>
      </UInput>
    </UFormField>
  </UForm>
</template>
